import React from 'react'

import TagInputV2 from '../../../TagInputv2'
import TagV2 from '../../AddCustomerModal/TagsSection/TagV2'

import useStyles from './styles'

const TaskTagsSection = ({ canEdit, modal, handleFields, values }) => {
  const { tags = [] } = values
  const classes = useStyles({ canEdit, modal })

  const handleUpdate = React.useCallback(
    (isDelete, tag, i) => {
      // Remove tag
      if (isDelete) {
        handleFields({ keyCode: -1 }, 'tags', i)
        return
      }

      // Add tag
      handleFields({ keyCode: 13, target: { value: tag } }, 'tags', 0)
    },
    [handleFields]
  )

  return (
    <>
      <TagInputV2
        height={24}
        inputClass={classes.inputClass}
        handleAddTag={tag => handleUpdate(false, tag)}
        alwaysShowInput
        noAutofocus
        customPlaceholder
        onResetValueTrigger={values.id}
        className={classes.inputRoot}
        disabled={!canEdit}
      />

      {tags.length === 0 ? (
        <div className={classes.noTags}>No tags</div>
      ) : (
        <div className={classes.tagList}>
          {tags.map((tag, i) => (
            <TagV2
              key={i}
              tag={tag}
              onDelete={() => handleUpdate(true, tag, i)}
              disabled={!canEdit}
            />
          ))}
        </div>
      )}
    </>
  )
}

export default TaskTagsSection
